import { render, staticRenderFns } from "./CardGamesCategory.vue?vue&type=template&id=7d9be2c8&"
import script from "./CardGamesCategory.vue?vue&type=script&lang=js&"
export * from "./CardGamesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports